const localAuction = "L";
const exportAuction = "E";
const Bidding_Through = {
  BuyNow: "BuyNow",
  Auction: "Auction"
}
const localAuctionTimeInMins = 95;
const exportAuctionTimeInMins = 60;
const buyNowAuctionTimeInMins = 1440;

export {
  localAuction,
  exportAuction,
  Bidding_Through,
  localAuctionTimeInMins,
  exportAuctionTimeInMins,
  buyNowAuctionTimeInMins
};